export const destinations = [
  {
    id: 1,
    name: 'Torres del Paine',
    location: 'Chilean Patagonia',
    category: 'Adventure',
    image: 'https://public.readdy.ai/ai/img_res/c80ace1ff1085d4dbd19f380cfb1d0b0.jpg',
  },
  {
    id: 2,
    name: 'San Pedro de Atacama',
    location: 'Atacama Desert',
    category: 'Nature',
    image: 'https://readdy.ai/api/search-image?query=stunning%20Atacama%20desert%20landscape%20with%20vast%20salt%20flats%20colorful%20mineral%20formations%20and%20distant%20volcanic%20peaks%20under%20dramatic%20sunset%20sky%20showcasing%20the%20unique%20beauty%20of%20Chilean%20desert%20with%20warm%20golden%20tones%20and%20ethereal%20atmosphere%20perfect%20for%20nature%20photography&width=800&height=600&seq=dest-atacama&orientation=landscape',
  },
  {
    id: 3,
    name: 'Valparaíso',
    location: 'Valparaíso Region',
    category: 'Culture',
    image: 'https://readdy.ai/api/search-image?query=colorful%20hillside%20houses%20of%20Valparaiso%20Chile%20with%20vibrant%20street%20art%20murals%20historic%20funiculars%20and%20panoramic%20ocean%20views%20showcasing%20the%20bohemian%20charm%20and%20cultural%20richness%20of%20this%20UNESCO%20heritage%20port%20city%20with%20bright%20colors%20and%20artistic%20atmosphere&width=800&height=600&seq=dest-valparaiso&orientation=landscape',
  },
  {
    id: 4,
    name: 'Easter Island',
    location: 'Pacific Ocean',
    category: 'History',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20moai%20statues%20on%20Easter%20Island%20with%20dramatic%20coastal%20cliffs%20and%20deep%20blue%20Pacific%20ocean%20showcasing%20ancient%20Rapa%20Nui%20culture%20and%20archaeological%20wonders%20under%20golden%20hour%20lighting%20with%20mystical%20atmosphere%20and%20historical%20significance&width=800&height=600&seq=dest-easter-island&orientation=landscape',
  },
  {
    id: 5,
    name: 'Puerto Varas',
    location: 'Los Lagos Region',
    category: 'Relaxation',
    image: 'https://readdy.ai/api/search-image?query=picturesque%20Puerto%20Varas%20lakeside%20town%20with%20snow-capped%20Osorno%20volcano%20reflection%20in%20pristine%20lake%20waters%20surrounded%20by%20lush%20green%20forests%20showcasing%20Chilean%20lake%20district%20beauty%20with%20serene%20atmosphere%20and%20stunning%20natural%20scenery%20perfect%20for%20relaxation&width=800&height=600&seq=dest-puerto-varas&orientation=landscape',
  },
  {
    id: 6,
    name: 'Chiloé',
    location: 'Chiloé Archipelago',
    category: 'Tradition',
    image: 'https://readdy.ai/api/search-image?query=traditional%20colorful%20palafitos%20stilt%20houses%20on%20water%20in%20Chiloe%20island%20with%20wooden%20churches%20and%20misty%20coastal%20landscape%20showcasing%20unique%20Chilean%20island%20culture%20and%20architecture%20with%20rustic%20charm%20and%20authentic%20atmosphere%20under%20soft%20natural%20lighting&width=800&height=600&seq=dest-chiloe&orientation=landscape',
  },
];
